// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__p3MeN","title_wrapper":"styles_title_wrapper__7FimO","block_wrapper":"styles_block_wrapper__39vCj","tags_wrapper":"styles_tags_wrapper__P0ZrR"};